/**
 * Shared layout, color, and typography tokens for Opportunity Cockpit screens.
 */

export const fonts = {
    sans: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
};

export const colors = {
    textPrimaryDark: '#2D2D4A',
    textHeading: '#3D3D4A',
    textMuted: '#9293A6',
    textSecondary: '#6B6B7B',
    link: '#2563EB',
    sectionDivider: '#ECEBEE',
    contactSurfaceBg: '#F8F9FC',
    contactSurfaceBorder: '#E8E8ED',
    overviewTintBg: 'rgba(128, 38, 255, 0.04)',
    overviewTintBorder: '1px solid rgba(128, 38, 255, 0.5)',
};

export const radii = {
    banner: 8,
    card: 4,
    button: 4,
};

export const spacing = {
    pageY: 16,
    sectionGap: 24,
    bannerPadding: '16px 20px',
    contactPadding: 24,
    contactPaddingBottom: 32,
};

/** Root page wrapper (horizontal inset below `lg` merged in index for ~1200px viewports) */
export const pageShell = {
    width: '100%',
    maxWidth: '100%',
    minWidth: 0,
    minHeight: 'calc(100vh - 67px)',
    boxSizing: 'border-box',
    paddingTop: spacing.pageY,
    paddingBottom: spacing.pageY,
    paddingLeft: 0,
    paddingRight: 0,
};

export const gridContainer = {
    width: '100%',
};

export const gridItem = {
    display: 'flex',
    minWidth: 0,
};

/** No opportunity cards configured / returned from meta */
export const emptyCardsState = {
    width: '100%',
    padding: '8px 4px',
    textAlign: 'center',
    fontFamily: fonts.sans,
    fontSize: 14,
    fontWeight: 400,
    color: colors.textMuted,
    lineHeight: 1.5,
};

/** Reusable flex blocks */
export const flex = {
    col: {
        display: 'flex',
        flexDirection: 'column',
    },
    colStart: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
    },
    rowCenter: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    rowWrap: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
    },
    stretchCol: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
    },
};

export const flexSpacer = {
    flex: 1,
    minHeight: 0,
};

/** Corner / decorative images */
export const absoluteBottomRight = {
    position: 'absolute',
    right: 12,
    bottom: 0,
    objectFit: 'contain',
    pointerEvents: 'none',
};

/** Typography presets (add fontFamily in consumers or merge with fonts.sans) */
export const type = {
    overviewTitle: {
        fontSize: 16,
        fontWeight: 600,
        color: colors.textHeading,
        lineHeight: 1.35,
        fontFamily: fonts.sans,
    },
    overviewSubtitle: {
        fontSize: 14,
        fontWeight: 400,
        color: colors.textMuted,
        lineHeight: 1.5,
        fontFamily: fonts.sans,
    },
    contactHeading: {
        fontSize: 16,
        fontWeight: 500,
        color: colors.textPrimaryDark,
        lineHeight: 1.35,
        fontFamily: fonts.sans,
    },
    contactBody: {
        fontSize: 14,
        fontWeight: 400,
        color: colors.textSecondary,
        lineHeight: 1.5,
        fontFamily: fonts.sans,
    },
    contactResponse: {
        fontSize: 14,
        fontWeight: 400,
        color: colors.textMuted,
        lineHeight: 1.5,
        fontFamily: fonts.sans,
    },
    contactLink: {
        fontSize: 14,
        fontWeight: 400,
        color: colors.link,
        textDecoration: 'none',
        wordBreak: 'break-all',
        fontFamily: fonts.sans,
    },
};
